// extracted by mini-css-extract-plugin
module.exports = {"redCard":"RedCardBadge_redCard__1s-d-"};